export default function Faq() {
  return (
    <>
      <section className="section" id="faq">
        <div className="container">
          <p className="section-eyebrow">Need help?</p>
          <h2 className="section-title">Frequently asked questions</h2>
          <div className="faq-list">
            <div className="faq-item">
              <button className="faq-q">
                Is per-seat sharing safe? <span>+</span>
              </button>
              <div className="faq-a">
                <p>
                  Yes. Every co-rider and driver on RouteRider is ID-verified,
                  and you can view ratings before you book. You also get live
                  trip tracking to share with family.
                </p>
              </div>
            </div>
            <div className="faq-item">
              <button className="faq-q">
                What's the difference between per-seat and full cab?{" "}
                <span>+</span>
              </button>
              <div className="faq-a">
                <p>
                  Per-seat sharing lets you book just the seats you need on a
                  shared cab at a lower price. Full cab reserves the entire
                  vehicle exclusively for you and your group.
                </p>
              </div>
            </div>
            <div className="faq-item">
              <button className="faq-q">
                Can I cancel my booking? <span>+</span>
              </button>
              <div className="faq-a">
                <p>
                  Yes, cancellations are free up to 2 hours before your
                  scheduled pickup time. After that, a small cancellation fee
                  may apply.
                </p>
              </div>
            </div>
            <div className="faq-item">
              <button className="faq-q">
                How do I become a fleet owner or driver? <span>+</span>
              </button>
              <div className="faq-a">
                <p>
                  Switch to the "Fleet Owner" tab at the top of the page and
                  sign up with your vehicle and license details. Our team
                  verifies and onboards you within 48 hours.
                </p>
              </div>
            </div>
            <div className="faq-item">
              <button className="faq-q">
                Do fares change during peak hours? <span>+</span>
              </button>
              <div className="faq-a">
                <p>
                  No. RouteRider uses fixed, upfront fares on every route — no
                  surge pricing, ever.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
